import React from "react";

interface ArchiveIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const ArchiveIcon: React.FC<ArchiveIconProps> = ({
  size = 20,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
    />
  </svg>
);
